import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-white-layout',
  templateUrl: './white-layout.component.html',
  styleUrls: ['./white-layout.component.scss']
})
export class WhiteLayoutComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
